module.exports = __webpack_public_path__ + "static/media/LI5.0b9b8f56.jpg";